import styled from 'styled-components';
import { Card } from '@shared/ui/Card';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(4)};
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

export const TitleBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const Subtitle = styled.div`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const StatGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
`;

export const MetricBox = styled(Card)`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const MetricLabel = styled.div`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${({ theme }) => theme.colors.text.muted};
`;

export const MetricValue = styled.div<{ $color?: string }>`
  font-size: 19px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: ${({ $color, theme }) => $color ?? theme.colors.text.primary};
`;

export const MetricNote = styled.div`
  font-size: 11px;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-top: 2px;
`;

export const TabNav = styled.div`
  display: flex;
  gap: 8px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  padding-bottom: 8px;
`;

export const TabButton = styled.button<{ $active: boolean }>`
  padding: 8px 16px;
  border-radius: ${({ theme }) => theme.radius.md};
  font-size: 13px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  background: ${({ $active }) =>
    $active ? 'rgba(16, 185, 129, 0.12)' : 'transparent'};
  color: ${({ $active, theme }) =>
    $active ? '#10b981' : theme.colors.text.secondary};
  border: 1px solid
    ${({ $active }) => ($active ? 'rgba(16, 185, 129, 0.35)' : 'transparent')};

  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
    background: ${({ theme }) => theme.colors.backgroundElevated};
  }
`;

export const TableWrap = styled(Card)`
  padding: 0;
  overflow: hidden;
  overflow-x: auto;
`;

export const RightTh = styled.th`
  text-align: right;
`;

export const RightTd = styled.td`
  text-align: right;
`;

export const TableNoticeTd = styled.td`
  text-align: center;
  padding: 24px;
`;

export const BoldTitle = styled.div`
  font-weight: 700;
`;

export const GreenProjectText = styled.div`
  font-size: 11px;
  color: #10b981;
  font-weight: 600;
`;

export const MutedText = styled.div`
  font-size: 11px;
  opacity: 0.7;
`;

export const PeriodText = styled.div`
  font-weight: 600;
`;

export const BatchTypeText = styled.span`
  font-size: 12px;
  font-weight: 600;
`;

export const NdflDeduction = styled.div`
  font-size: 11px;
  color: #ef4444;
`;

export const CanteenDeduction = styled.div`
  font-size: 11px;
  color: #f59e0b;
`;

export const NetPayout = styled.div`
  font-weight: 800;
  font-size: 14px;
  color: #10b981;
`;

export const DiscrepancyBadge = styled.div<{ $isOk: boolean }>`
  font-weight: 700;
  color: ${({ $isOk }) => ($isOk ? '#10b981' : '#ef4444')};
`;

export const SubExplanationText = styled.div`
  font-size: 10px;
  opacity: 0.7;
`;

export const InRegistryText = styled.span`
  font-size: 12px;
  opacity: 0.6;
`;

export const SiteSubText = styled.div`
  font-size: 11px;
  opacity: 0.75;
`;

export const ShiftDiffText = styled.div<{ $isOk: boolean }>`
  font-size: 10px;
  font-weight: 700;
  color: ${({ $isOk }) => ($isOk ? '#10b981' : '#f59e0b')};
`;

export const GrossAccruedText = styled.div`
  font-weight: 700;
`;

export const CanteenSiteTd = styled.td`
  text-align: right;
  color: #f59e0b;
`;

export const TotalLaborCost = styled.div`
  font-weight: 800;
  font-size: 14px;
  color: #0ea5e9;
`;

export const LoadingCard = styled(Card)`
  padding: 24px;
`;

export const ErrorCard = styled(Card)`
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const AlertBanner = styled.div<{ $tone: 'success' | 'warning' }>`
  padding: 10px 16px;
  border-radius: ${({ theme }) => theme.radius.md};
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${({ $tone }) =>
    $tone === 'success'
      ? 'background: rgba(16, 185, 129, 0.12); color: #10b981; border: 1px solid rgba(16, 185, 129, 0.3);'
      : 'background: rgba(245, 158, 11, 0.12); color: #f59e0b; border: 1px solid rgba(245, 158, 11, 0.3);'}
`;
